import React from 'react'
import {friendElement,labledFriend,Breadcrumb} from './myFunctions.js';
export default function SearchResultsListEntry({labledFriend,oym,dropBreadcrumb,getSearchItem}) {
    function dropFriendBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb(labledFriend.friend.sortKey,friendElement(oym,labledFriend.friend,dropBreadcrumb)));
    }
    console.log(labledFriend);
    console.log(labledFriend.label);
    // console.log(authenticated);
    // if (authenticated!==undefined&&authenticated){
        return (
            <>
            <tr>
            <td><button onClick={dropFriendBreadcrumb}>{labledFriend.label }</button> &nbsp;</td>
            </tr>
            </>
        )
    // } else {
    //     return (
    //         <>
    //         <tr>
    //         <td>{labledFriend.friend.sortKey}</td>
    //         </tr>
    //         </>
    //     )
    // }
}
